import ticketDetails from '../localization-messages/ticketDetails/en-US.json';
import ticketCancelForm from '../localization-messages/ticketCancelForm/en-US.json';
import ticketListing from '../localization-messages/ticketListing/en-US.json';
import ticketForm from '../localization-messages/ticketForm/en-US.json';
import headerFooter from '../localization-messages/headerFooter/en-US.json';
import reconfirmUserDetailsModal from '../localization-messages/reconfirmUserDetailsModal/en-US.json';
import termsModal from '../localization-messages/termsModal/en-US.json';

export const enUSTranslations = {
  ticketDetails,
  ticketCancelForm,
  ticketListing,
  ticketForm,
  headerFooter,
  reconfirmUserDetailsModal,
  termsModal,
};
